import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=user
  const [companies, setCompanies] = useState([]);
  const [activeCompanyId, setActiveCompanyId] = useState(localStorage.getItem("sahel_company") || null);

  const applyMe = useCallback((data) => {
    setUser(data.user);
    setCompanies(data.companies || []);
    const stored = localStorage.getItem("sahel_company");
    const ids = (data.companies || []).map((c) => c.id);
    if (stored && ids.includes(stored)) setActiveCompanyId(stored);
    else if (data.companies && data.companies.length) {
      setActiveCompanyId(data.companies[0].id);
      localStorage.setItem("sahel_company", data.companies[0].id);
    } else setActiveCompanyId(null);
  }, []);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      applyMe(data);
      return data;
    } catch {
      setUser(false);
      setCompanies([]);
      return null;
    }
  }, [applyMe]);

  useEffect(() => {
    if (localStorage.getItem("sahel_token")) refresh();
    else setUser(false);
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("sahel_token", data.token);
    await refresh();
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("sahel_token", data.token);
    setUser(data.user);
    setCompanies([]);
    setActiveCompanyId(null);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("sahel_token");
    localStorage.removeItem("sahel_company");
    setUser(false);
    setCompanies([]);
    setActiveCompanyId(null);
  };

  const switchCompany = (id) => {
    setActiveCompanyId(id);
    localStorage.setItem("sahel_company", id);
  };

  const activeCompany = companies.find((c) => c.id === activeCompanyId) || null;

  return (
    <AppContext.Provider value={{ user, companies, activeCompany, activeCompanyId, switchCompany, login, register, logout, refresh }}>
      {children}
    </AppContext.Provider>
  );
}
